/* libs/oyan-ui/src/lib/features/admin/containers/user-profile-shell/user-profile-shell.component.scss */
.user-profile-info {
  height: auto !important;
}
.user-profile-info__container {
  font-size: 12px;
}
/*# sourceMappingURL=user-profile-shell.component.css.map */
